import { stringify } from 'qs'
import { useCustomSWR } from 'utils/hooks/fetchers'
import RequestCore, { lsGetWithToken } from 'utils/request'

export const useCatalogsServiceMenus = (props = { limit: 999 }) => {
  const genUrl = () =>
    RequestCore.getToken()
      ? [`/catalogs/serviceMenus?${stringify(props)}`, RequestCore.getToken()]
      : `/catalogs/serviceMenus?${stringify(props)}`

  return useCustomSWR(genUrl, lsGetWithToken)
}
